// startup
// Load entry module and return exports
__webpack_require__("./assets/src/js/app.ts");
// This entry module is referenced by other modules so it can't be inlined
var __webpack_exports__ = __webpack_require__("./assets/src/scss/main.scss");
